export default __webpack_public_path__ + "static/HDSI-9876398570b018c39634ae7f063bcfd9.jpg";